export class PredictedPenetrance {
  PredictedPenetranceID: number;
  Value: string;

  constructor(id: number, value: string) {
    this.PredictedPenetranceID = id;
    this.Value = value;
  }
}
